import {initializeApp} from 'firebase/app'
import {getFirestore} from 'firebase/firestore'

const firebaseConfig = {
	apiKey: 'AIzaSyDrFSENHMun6zTCkOsio0AR8eq6xA5QVTQ',
	authDomain: 'andreea-firebase-f0ab1.firebaseapp.com',
	databaseURL:
		'https://andreea-firebase-f0ab1-default-rtdb.europe-west1.firebasedatabase.app',
	projectId: 'andreea-firebase-f0ab1',
	storageBucket: 'andreea-firebase-f0ab1.appspot.com',
	messagingSenderId: '534438611723',
	appId: '1:534438611723:web:aa5606727d7e3b886eb00e',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
// const auth = firebase.auth()

export default db
